import styled, { css } from "styled-components";

import { windowWidth } from "@styles/global";

interface ContainerProps {
  searchIsActive: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 17px;

  @media (min-width: ${windowWidth.tablet}) {
    * {
      cursor: pointer;
    }

    ${({ searchIsActive }) => !searchIsActive
      && css`
        & > :not(:hover) {
          transition: all 0.2s;
        }

        & > :hover {
          transition: all 0.5s;
          transform: scale(1.2);
        }
      `}
  }

  @media (max-width: ${windowWidth.tablet}) {
    > :last-child {
      display: none;
      visibility: hidden;
    }
  }
`;

export const LanguageIcon = styled.div`
  display: flex;
  align-items: center;
`;

export const ManageAccountsIcon = styled.div`
  display: flex;
  align-items: center;
`;
